import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onAccept }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem('userHasAcceptedCookies');
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('userHasAcceptedCookies', 'true');
    setIsVisible(false);
    if (onAccept) onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('userHasAcceptedCookies', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <span className="cookie-icon">🍪</span>
          <p>
            Этот сайт использует cookies и Яндекс.Метрику для аналитики. 
            Нажимая «Принять», вы соглашаетесь с нашей{' '}
            <a href="/policy" className="cookie-policy-link">
              Политикой обработки персональных данных
            </a>
            .
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>
            Принять
          </button>
          <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>
            Отклонить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;